import { Component, OnInit } from '@angular/core';
import { HaPatientlistService } from '../../services/HaPatientList.service';
import { Router } from '@angular/router';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ShareMultiplePatientModal } from '../../models/ShareMultiplePatient.model';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-ha-share-patient',
  templateUrl: './ha-share-patient.component.html',
  styleUrls: ['./ha-share-patient.component.css']
})

export class HaSharePatientComponent implements OnInit {
  constructor(private _service: HaPatientlistService, private router: Router) {}
  patData: any[];
  allPatData: any[];
  doctorList: any[] = [];
  doctorListAll: any[] = [];
  patDataToShare: any[] = [];
  searchPatientTerm: string = "";
  showOverlayPatientListShare: boolean = false;
  selectAllCheck: boolean = false;
  searchTermDoctorMulti: string = "";
  doctorModalShareBit: boolean = false;
  mainViewError = new ErrorModel();
  shareLoader:boolean = false;

  ngOnInit() {
    this.patData = [];
    this.patDataToShare = [];
    // this.getDoctors();
    this.getPatients();
  }

  getDoctors() {
    this._service.getDoctorsList().subscribe(
    (data: any[]) => {
      this.doctorList = data;
      this.doctorListAll = data;
    },
    (error) => {
      AlertMessages.Show('Failed','Could not load Doctors!',AlertType.Error);
      this.getPatients();
    });
  }

  routeBack() {
    this.router.navigate(['Hospital/HAAdmin/PatientLists'], {
      queryParams: {}
    });
  }

  getPatients() {
    this.showOverlayPatientListShare = true;
    this.mainViewError.display = false;
    this._service.getSharePatients().subscribe(
    (data: any[]) => {
      this.allPatData = data;
      this.patData = data;
      this.getDoctors();
    },
    (error) => {
      this.mainViewError.error =  error;
      this.mainViewError.display = true;

    }).add(() => {
      this.showOverlayPatientListShare = false;
    });
  }


  selectPatient(event, id) {
    if (event.target.checked == true) {

      this.changePatientChecks(id, true);
    } else {
      this.selectAllCheck = false;
      let indexToShare = this.patDataToShare.filter(patient => patient.id == id)[0];
      if (indexToShare !== undefined) {
        let index = this.patDataToShare.indexOf(indexToShare);
        this.patDataToShare.splice(index, 1);
      }
      this.changePatientChecks(id,false);
    }
  }


  changePatientChecks(id,type) {
    let index = this.patData.filter(i => i.id == id)[0];
    if (index !== undefined) {
      var indexOne = this.patData.indexOf(index);
        this.patData[indexOne].isChecked = type;
        if (type) this.patDataToShare.push(this.patData[indexOne]);
    }
  }


  selectAllPatient(event) {
    this.patDataToShare = [];
    let status = event.target.checked == true ? true : false;
    this.selectAllCheck = status;
    this.patData.forEach((e) => {
      if(status) this.patDataToShare.push(e);
      e.isChecked = status;
    });
  }

  searchPatient(searchText) {
    this.selectAllCheck = false;
    this.patDataToShare = [];
    this.patData.forEach((e) => {
      e.isChecked = false;
    });
    if (!this.patData || !searchText) {
      this.patData = this.allPatData;
    }
    this.allPatData.forEach(element => {
      if (element.doctorName == null) {
        element.doctorName = "";
      }
      if (element.mobileNo == null) {
        element.mobileNo = "";
      }
      if (element.emailId == null) {
        element.emailId = "";
      }
    });
    this.patData = this.allPatData.filter(ad =>
      ad.fullName.toLowerCase().indexOf(searchText.toLowerCase().trim()) !== -1 ||
      ad.patientId.toLowerCase().indexOf(searchText.toLowerCase().trim()) !== -1 ||
      ad.doctorName.toLowerCase().indexOf(searchText.toLowerCase().trim()) !== -1 ||
      ad.mobileNo.toLowerCase().indexOf(searchText.toLowerCase().trim()) !== -1 ||
      ad.emailId.toLowerCase().indexOf(searchText.toLowerCase().trim()) !== -1
    );
  }

  searchDoctor(searchText) {
    if (!this.doctorList || !searchText) {
      this.doctorList = this.doctorListAll;
    }
    this.doctorList = this.doctorListAll.filter(ad =>
      ad.name.toLowerCase().indexOf(searchText.toLowerCase().trim()) !== -1
    );
  }

  shareToDoc() {
    if (!this.selectAllCheck) {
    if (this.patDataToShare != undefined && this.patDataToShare != null) {
      if (this.patDataToShare.length > 0) {
        if(this.doctorList.length > 1) {
          this.doctorModalShareBit = true;
        } else {
          
        AlertMessages.Show('Cannot Share', 'No Doctor available!', AlertType.Warning);
        }
      } else {
        this.doctorModalShareBit = false;
        AlertMessages.Show('WARNING', 'Select an Item First', AlertType.Warning);
      }
    } else {
      this.doctorModalShareBit = false;
      AlertMessages.Show('WARNING', 'Select an Item First', AlertType.Warning);
    }
  } else {
    AlertMessages.Show('Not Allowed','Cannot share all!',AlertType.Warning);
  }
  }

  closeDoctorShare() {
    this.doctorModalShareBit = false;
    this.searchTermDoctorMulti = '';
    this.searchDoctor(this.searchTermDoctorMulti);
  }

  sharePatientWithDoc(id) {
    if (this.patDataToShare != null && this.patDataToShare != undefined) {
      let actualList = this.patDataToShare.filter(patient => patient.eaLoginId !== id);
      if ( actualList.length) {
        let shareModal:ShareMultiplePatientModal = new ShareMultiplePatientModal(actualList,id);
        this.shareLoader = true;
        this._service.shareMultiplePatient(shareModal).subscribe(
        (data) => {
          this.doctorList.forEach(e => {
            e.isChecked = false;
          })
          this.patData.forEach(e => {
            e.isChecked = false;
          })
          this.patDataToShare = [];
          if(data) {
            AlertMessages.Show('Success', 'Shared with selected Doctor', AlertType.Success);

          } else {
            AlertMessages.Show('Already Shared', 'Patient is already shared', AlertType.Warning);

          }
          // this.doctorModalShareBit = false;
          this.closeDoctorShare();
        },
        (error) => {
          AlertMessages.Show('Failed','could not share',AlertType.Error);
        }).add(() => {
          this.shareLoader = false;
        });
      } else {
        AlertMessages.Show('Not Allowed','Sharing with own Doctor', AlertType.Warning);
      }
    } else {
      AlertMessages.Show('WARNING', 'Select an Item First', AlertType.Warning);
    }
  }
}
